import { ListableCategoryBasicResponse, CategoryWithChildrenResponse } from '@bluestone-node-sdk/pim';
import BaseAPIClient from '~/clientUtils/baseApiClient';
import { Election } from '~/definitions/election';

class CompanyApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getCompanyList(): Promise<ListableCategoryBasicResponse['data']> {
        return this.request({
            method: 'GET',
            url: `/api/company/list`,
        });
    }

    async getElectionByCompanyId(
        id: string,
        data: { electionId: string }
    ): Promise<{ election: CategoryWithChildrenResponse; electionList: Election[] }> {
        return this.request({
            method: 'POST',
            url: `/api/company/${id}/election`,
            data,
        });
    }

    async getCompanyByUserNumber(number: string): Promise<ListableCategoryBasicResponse['data']> {
        return this.request({
            method: 'GET',
            url: `/api/company/getCompany/${number}`,
        });
    }
}

const companyApi = new CompanyApi();

export default companyApi;
